/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import IconCartao from 'assets/images/icon_cartao.svg';
import IconBoleto from 'assets/images/icon_boleto.svg';
import CardPayment from 'components/atoms/card_payment';
import TicketPayment from 'components/atoms/ticket_payment';
import RadioButtonSelect from 'components/atoms/radio_button_select';
import ErrorCardModal from 'components/atoms/error_card_modal';
import ImgBandeiras from 'assets/images/bandeiras_cartao.svg';
import { ApplicationState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { updateSaless } from 'store/modules/update_sales_store/actions';
import { createSales } from 'store/modules/create_sales_store/actions';
import { PlansState } from 'store/modules/plans_store/types';
import { getTheLastSalePhase } from 'services/actions/get_the_last_sale_phase';
import { UpdateSaleState } from 'store/modules/update_sales_store/types';
import { CreateSaleState } from 'store/modules/create_sales_store/types';
import { SimulateAllState } from 'store/modules/simulate_all_store/types';
import LoaderPayment from 'components/atoms/loader_payment';
import { ParcelamentoServicesState } from 'store/modules/get_package_service_store/types';
import { PanelState } from 'store/modules/panel_store/types';
import { MyAccountTypes } from 'store/modules/my_account_store/types';
import { Container } from './styles';

interface PaymentProps {
  typePayment: (tipoPagamento: string, updateAll?: boolean) => void;
  paymentType: string;
  dadosPlanCheckout: any;
  parcelas: object | null;
  parcelaValorFinal: string;
  parcelaCheckout: boolean;
  parcelaRequest: number;
  simulateRequest: boolean;
}

const Payment = (props: PaymentProps) => {
  const PAYMENT_METHOD_CARD = 10;
  const PAYMENT_METHOD_INVOICE = 1;
  const {
    typePayment,
    paymentType,
    dadosPlanCheckout,
    parcelas,
    parcelaValorFinal,
    parcelaCheckout,
    parcelaRequest,
    simulateRequest,
  } = props;
  const [selectedPaymentCondition, setSelectedPaymentCondition] = useState<string>('1');
  const [cardHolderName, setCardHolderName] = useState<string>('');
  const [cardNumber, setCardNumber] = useState<string>('');
  const [cardExpirationMonth, setCardExpirationMonth] = useState<string>('');
  const [cardExpirationYear, setCardExpirationYear] = useState<string>('');
  const [cardCvv, setCardCvv] = useState<string>('');
  const [cardBrand, setCardBrand] = useState<string>('');
  const [salePhase, setSalePhase] = useState<number>(2);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalError, setShowModalError] = useState<boolean>(false);
  const [typeSale, setTypeSale] = useState<string>('');
  const [buttonSale, setButtonSale] = useState<boolean>(true);
  const [namePayment, setNamePayment] = useState<string>('card');

  const dispatch = useDispatch();

  const { simulate_all } = useSelector<ApplicationState, SimulateAllState>(
    (state) => state.session.simulate_all,
  );
  const { current_layout } = useSelector<ApplicationState, PlansState>(
    (state) => state.session.plans,
  );
  const { update_sale, request } = useSelector<ApplicationState, UpdateSaleState>(
    (state) => state.session.update_sale,
  );
  const { create_sale, requestCreate } = useSelector<ApplicationState, CreateSaleState>(
    (state) => state.session.create_sale,
  );
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const { requestParcelamento, parcelamento } = useSelector<
    ApplicationState,
    ParcelamentoServicesState
  >((state) => state.session.parcelamento);

  const optionDescription = (installments: number, value: string) => {
    if (value[1] === String(parcelamento?.valor_final))
      return `R$ ${parseFloat(value[1]).toFixed(2).replace('.', ',')} à vista`;
    return `Parcelado em ${value[0]}x de R$ ${parseFloat(value[1]).toFixed(2).replace('.', ',')}`;
  };

  const optionDescriptionCheckout = (installments: number, value: string) => {
    if (installments === 1)
      return `R$ ${parseFloat(parcelaValorFinal).toFixed(2).replace('.', ',')} à vista`;
    return `Parcelado em ${installments}x de R$ ${parseFloat(value).toFixed(2).replace('.', ',')}`;
  };

  useEffect(() => {
    (async () => {
      setSalePhase(await getTheLastSalePhase());
    })();
  }, []);

  const createSale = async () => {
    const plan = {
      valor_adicional:
        simulate_all?.original?.[namePayment][simulate_all?.package_name]?.original
          ?.valor_adicional,
      valor_base:
        simulate_all?.original?.[namePayment][simulate_all?.package_name]?.original?.valor_base,
      valor_negociacao:
        simulate_all?.original?.[namePayment][simulate_all?.package_name]?.original
          ?.valor_negociacao,
      valor_total:
        simulate_all?.original?.[namePayment][simulate_all?.package_name]?.original?.valor_final,
      valor_variacao_forma_pagamento:
        simulate_all?.original?.[namePayment][simulate_all?.package_name]?.original
          ?.valor_variacao_forma_pagamento,
      renewal: Number(current_layout?.renewal),
      status_id: 1,
      servicos: simulate_all?.original?.[namePayment][
        simulate_all?.package_name
      ]?.original?.servicos?.map((dados) => {
        return {
          plano_id: simulate_all?.plan_id,
          plano_nome: dados.nome,
          fase_servico_id: salePhase,
          servico_id: dados.id,
          valor_base: dados.valor,
        };
      }),
      payment_condition_id: selectedPaymentCondition,
      payment_form: paymentType === 'cartao' ? PAYMENT_METHOD_CARD : PAYMENT_METHOD_INVOICE,
      credit_card_holder_name: cardHolderName,
      credit_card_number: cardNumber.replace(/\s+/g, ''),
      credit_card_expiration_month: cardExpirationMonth,
      credit_card_expiration_year: cardExpirationYear,
      credit_card_cvv: cardCvv,
      credit_card_brand: cardBrand,
      selectedPackageName: simulate_all?.package_name,
      update_client_register: false,
    };
    dispatch(createSales(plan));
    setShowModal(true);
    setTypeSale('create_sale');
  };

  const updateSale = async () => {
    const data = {
      sale_id: dadosPlanCheckout?.selected_package[0]?.sale?.id,
      credit_card_holder_name: cardHolderName,
      credit_card_number: cardNumber.replace(/\s+/g, ''),
      credit_card_expiration_month: cardExpirationMonth,
      credit_card_expiration_year: cardExpirationYear,
      credit_card_cvv: cardCvv,
      credit_card_brand: cardBrand,
      update_client_register: panel?.registration_type_validation === 5,
    };
    dispatch(updateSaless(data));
    setShowModal(true);
    setTypeSale('update_sale');
  };

  useEffect(() => {
    if (showModal && update_sale?.is_charged === false && update_sale?.return_code !== null) {
      setShowModalError(true);
    } else if (showModal && create_sale?.is_charged === null && create_sale?.return_code !== null) {
      setShowModalError(true);
    } else if (
      panel?.registration_type_validation === 5 &&
      update_sale?.is_charged === true &&
      update_sale?.return_code === null
    ) {
      window.location.href = '/painel';
    } else if (showModal && update_sale?.is_charged === true && update_sale?.return_code === null) {
      window.location.href = '/compra_finalizada';
    } else if (showModal && create_sale?.is_charged === true && create_sale?.return_code === null) {
      window.location.href = '/compra_realizada';
    }
  }, [update_sale, create_sale]);

  useEffect(() => {
    paymentType === 'boleto' ? setButtonSale(false) : setButtonSale(true);
    paymentType === 'cartao' ? setNamePayment('card') : setNamePayment('invoice');
  }, [paymentType]);

  useEffect(() => {
    requestCreate.loading ? setButtonSale(true) : setButtonSale(false);
  }, [requestCreate]);

  useEffect(() => {
    request.loading ? setButtonSale(true) : setButtonSale(false);
  }, [request]);

  useEffect(() => {
    cardHolderName === '' ||
    cardNumber === '' ||
    cardExpirationMonth === '' ||
    cardBrand === '' ||
    cardExpirationMonth === '__' ||
    cardExpirationYear === '__' ||
    cardCvv === '' ||
    cardCvv === '__'
      ? setButtonSale(true)
      : setButtonSale(false);
  }, [cardHolderName, cardNumber, cardExpirationMonth, cardBrand, cardExpirationYear, cardCvv]);

  const onClickHandler = async () => {
    if (paymentType === 'boleto' && dadosPlanCheckout?.selected_package[0]?.sale?.id) {
      setButtonSale(false);
      dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' });
      window.location.href = '/minha_conta/boletos_online';
      return;
    }
    dadosPlanCheckout?.selected_package[0]?.sale?.id ? updateSale() : createSale();

    if (paymentType === 'boleto') {
      dispatch({ type: MyAccountTypes.VIEW_COMPONENT, view: 'boletos_online' });
      window.location.href = '/minha_conta/boletos_online';
    }
  };

  const condicaoPagamentoCheckout = () => {
    return paymentType === 'cartao' ? (
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-12">
            <RadioButtonSelect
              isChecked={paymentType === 'cartao'}
              text="cartao"
              toggleSelectContracts={typePayment}
            />
            <img className="px-1" src={IconCartao} alt="Icone Cartão" /> Cartão de Crédito
          </div>
        </div>
      </div>
    ) : (
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-12">
            <RadioButtonSelect
              isChecked={paymentType === 'boleto'}
              text="boleto"
              toggleSelectContracts={typePayment}
            />
            <img className="px-1" src={IconBoleto} alt="Icone Cartão" /> Boleto
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container>
      <div className="col-md-12 p-0">
        <div className="card">
          {simulateRequest ? (
            <div>
              <LoaderPayment />
            </div>
          ) : (
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  {!dadosPlanCheckout ? (
                    <div className="row">
                      <div className="col-md-7">
                        <RadioButtonSelect
                          isChecked={paymentType === 'cartao'}
                          text="cartao"
                          toggleSelectContracts={typePayment}
                        />
                        <img className="px-1" src={IconCartao} alt="Icone Cartão" /> Cartão de
                        Crédito
                      </div>
                      {!simulate_all?.card_payment && (
                        <div className="col-md-5">
                          <RadioButtonSelect
                            isChecked={paymentType === 'boleto'}
                            text="boleto"
                            toggleSelectContracts={typePayment}
                          />
                          <img className="px-1" src={IconBoleto} alt="Icone Cartão" /> Boleto
                        </div>
                      )}
                    </div>
                  ) : (
                    condicaoPagamentoCheckout()
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  {paymentType === 'cartao' ? (
                    <CardPayment
                      cardHolderName={cardHolderName}
                      setCardHolderName={setCardHolderName}
                      cardNumber={cardNumber}
                      setCardNumber={setCardNumber}
                      cardExpirationMonth={cardExpirationMonth}
                      setCardExpirationMonth={setCardExpirationMonth}
                      cardExpirationYear={cardExpirationYear}
                      setCardExpirationYear={setCardExpirationYear}
                      cardCvv={cardCvv}
                      setCardCvv={setCardCvv}
                      cardBrand={cardBrand}
                      setCardBrand={setCardBrand}
                    />
                  ) : (
                    <TicketPayment />
                  )}
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Parcelas</label>
                    {requestParcelamento.loading ? (
                      <div>
                        <LoaderPayment />
                      </div>
                    ) : (
                      <select
                        className="form-control"
                        onChange={(event) => setSelectedPaymentCondition(event.target.value)}
                        defaultValue=""
                      >
                        {parcelaCheckout
                          ? parcelaCheckout &&
                            parcelaRequest === 200 && (
                              <option key="payment_condition_option_5" value={Number(parcelas)}>
                                {optionDescriptionCheckout(
                                  dadosPlanCheckout?.selected_package[0]?.sale?.parcelas,
                                  String(parcelas),
                                )}
                              </option>
                            )
                          : parcelamento?.parcelas &&
                            Object.entries(parcelamento?.parcelas)?.map(
                              (paymentCondition: any, idx: number) => {
                                return (
                                  <option key={`payment_condition_option_${idx}`} value={idx + 1}>
                                    {optionDescription(idx, paymentCondition)}
                                  </option>
                                );
                              },
                            )}
                      </select>
                    )}
                  </div>
                  <p className="mt-2">
                    Ao confirmar a compra, você declara estar ciente e de acordo com os nossos
                    Termos de Uso, Responsabilidade Civil e Política de Privacidade.
                    <a
                      href="https://conlicitacao.com.br/termos-de-uso"
                      target="blank"
                      style={{ marginLeft: '5px' }}
                    >
                      Termos de uso
                    </a>
                  </p>
                  <button
                    type="button"
                    className="btn btn-primary btn-lg btn-block"
                    disabled={buttonSale}
                    onClick={() => onClickHandler()}
                  >
                    Confirmar compra
                  </button>
                  {paymentType === 'cartao' && (
                    <div>
                      <p className="mt-2">
                        *Para sua comodidade, a assinatura será renovada automaticamente ao preço
                        atual da assinatura.
                      </p>
                      <p className="mt-2">
                        *A emissão de apólices de seguro garantia por usuários cadastrados nesta
                        conta gera obrigações autônomas junto às seguradoras e é de responsabilidade
                        exclusiva do contratante.
                      </p>
                      <img src={ImgBandeiras} alt="Bandeira cartões" className="mt-2" />
                    </div>
                  )}
                  {paymentType === 'boleto' && (
                    <div>
                      <p className="mt-2">
                        *A emissão de apólices de seguro garantia por usuários cadastrados nesta
                        conta gera obrigações autônomas junto às seguradoras e é de responsabilidade
                        exclusiva do contratante.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {showModalError && (
            <ErrorCardModal
              setShowModal={setShowModal}
              showModal={showModal}
              typeSale={typeSale}
              saleService=""
            />
          )}
        </div>
      </div>
    </Container>
  );
};
export default Payment;
